import {useDispatch, useSelector} from "react-redux";
import View from "./View";
import {changeTransform} from "store/actions/transform";
import {ACTION_TYPE, TRANSFORM_TYPE} from "utils";
import {useEffect} from "react";
import {redo, undo} from "store/actions/undoredo";

export default function Container() {
  const dispatch = useDispatch();
  const isUndoAble = useSelector(state => state.undoredo.isUndoAble);
  const isRedoAble = useSelector(state => state.undoredo.isRedoAble);
  const currentSelectedTab = useSelector(state => state.transform.transformType);

  useEffect(() => {
    dispatch(changeTransform(TRANSFORM_TYPE.TRANSLATE));
  }, []);

  const onClickRedo = () => {
    dispatch(
      redo({
        command: ACTION_TYPE.REDO,
        timestamp: Date.now(),
      }),
    );
  };

  const onClickUndo = () => {
    dispatch(
      undo({
        command: ACTION_TYPE.UNDO,
        timestamp: Date.now(),
      }),
    );
  };

  const onClickSelectTab = tab => {
    dispatch(changeTransform(tab));
  };
  return (
    <View
      isUndoAble={isUndoAble}
      isRedoAble={isRedoAble}
      currentSelectedTab={currentSelectedTab}
      onClickSelectTab={onClickSelectTab}
      onClickUndo={onClickUndo}
      onClickRedo={onClickRedo}
    />
  );
}
